/* SELL CGM — quote basket + quote page. Replaces the "SA Request a Quote" app. */
(function () {
  'use strict';

  var STORAGE_KEY = 'scgm_quote_v1';
  // Set window.SCGM_QUOTE_PAGE before this script to test on a different page (e.g. /pages/quote-test).
  var QUOTE_PAGE = window.SCGM_QUOTE_PAGE || '/pages/request-for-quote';
  var MAX_QTY = 200;

  /* ------------------------------------------------------------ basket */

  var Basket = {
    read: function () {
      try {
        var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(items) ? items : [];
      } catch (e) {
        return [];
      }
    },
    write: function (items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      } catch (e) {}
      updateCounter();
    },
    add: function (item) {
      var items = Basket.read();
      var existing = items.filter(function (i) { return i.variant_id === item.variant_id; })[0];
      if (existing) existing.quantity = Math.min(MAX_QTY, existing.quantity + item.quantity);
      else items.push(item);
      Basket.write(items);
    },
    setQty: function (variantId, qty) {
      var items = Basket.read();
      items.forEach(function (i) {
        if (i.variant_id === variantId) i.quantity = Math.max(1, Math.min(MAX_QTY, qty));
      });
      Basket.write(items);
    },
    remove: function (variantId) {
      Basket.write(Basket.read().filter(function (i) { return i.variant_id !== variantId; }));
    },
    clear: function () { Basket.write([]); },
    count: function () {
      return Basket.read().reduce(function (n, i) { return n + i.quantity; }, 0);
    },
  };

  /* ------------------------------------------------ ad attribution */

  // Click IDs arrive on the landing page (?fbclid=… / ?gclid=…) but the quote is submitted pages
  // later, so remember them for 90 days. They go to the Worker with the quote and on to Meta / Google.
  var ATTR_KEY = 'scgm_attr_v1';
  var ATTR_MAX_AGE = 90 * 24 * 60 * 60 * 1000;
  var CLICK_PARAMS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid'];
  // Where the visit came from, so quotes without an ad click ID can still be told apart
  // (Ava's texted links, organic search, other sites, direct). Last touch wins.
  var UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function externalReferrer() {
    try {
      if (!document.referrer) return '';
      var host = new URL(document.referrer).hostname.toLowerCase();
      if (host === location.hostname || /(^|\.)sellcgm\.com$|myshopify\.com$/.test(host)) return '';
      return host;
    } catch (e) {
      return '';
    }
  }

  // Google Ads "Submit lead form" conversion + Meta pixel "Lead". Fired on the page after a successful quote.
  var GOOGLE_CONVERSION = window.SCGM_GOOGLE_CONVERSION || 'AW-17646510603/nMLBCNiupcMcEIvEwd5B';
  var META_PIXEL = window.SCGM_META_PIXEL || '1002974338287354';
  var PENDING_KEY = 'scgm_quote_conversion';
  // Google Analytics 4 (property sellcgm.com). GA4 is a destination inside Shopify's Google tag
  // (GT-NSKZ3ZWT), which reaches it but only sends its page views to Google Ads and Merchant Center. So the
  // page view is sent to GA4 here, and our funnel steps (track) and the submitted quote (generate_lead)
  // reach it through the same tag and _ga cookie. There is no separate G- tag to config (it 404s).
  var GA4_ID = window.SCGM_GA4_ID || 'G-XJP19N98WX';
  try { if (typeof window.gtag === 'function') window.gtag('event', 'page_view', { send_to: GA4_ID }); } catch (e) {}

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  // Some in-app browsers (Facebook/Instagram) lose localStorage between pages, so the touch is also
  // mirrored into a small first-party cookie. Click IDs stay out of it: Meta's _fbc and Google's _gcl_aw
  // cookies already carry them.
  var ATTR_COOKIE = 'scgm_attr';
  var MIRROR_KEYS = UTM_PARAMS.concat(['landing', 'referrer', 'fbc_seen']);

  function prune(saved) {
    Object.keys(saved).forEach(function (k) {
      if (!saved[k] || Date.now() - saved[k].ts > ATTR_MAX_AGE) delete saved[k];
    });
    return saved;
  }

  // Meta's _fbc is "fb.1.<ms when the click was seen>.<fbclid>".
  function fbcTime(fbc) {
    var t = Number(String(fbc || '').split('.')[2]);
    return t > 0 ? t : 0;
  }

  var Attribution = {
    read: function () {
      var saved = {};
      try { saved = JSON.parse(localStorage.getItem(ATTR_KEY) || '{}') || {}; } catch (e) {}
      Attribution.fromCookie = false;
      if (!Object.keys(saved).length) {
        try { saved = JSON.parse(cookie(ATTR_COOKIE) || '{}') || {}; } catch (e) { saved = {}; }
        Attribution.fromCookie = Object.keys(saved).length > 0;
      }
      return prune(saved);
    },
    write: function (saved) {
      try { localStorage.setItem(ATTR_KEY, JSON.stringify(saved)); } catch (e) {}
      try {
        var mirror = {};
        MIRROR_KEYS.forEach(function (k) { if (saved[k]) mirror[k] = saved[k]; });
        document.cookie = ATTR_COOKIE + '=' + encodeURIComponent(JSON.stringify(mirror)) +
          '; max-age=' + ATTR_MAX_AGE / 1000 + '; path=/; SameSite=Lax' +
          (location.protocol === 'https:' ? '; Secure' : '');
      } catch (e) {}
    },
    capture: function () {
      var params = new URLSearchParams(location.search);
      var saved = Attribution.read();
      var changed = Attribution.fromCookie; // copy a cookie-restored touch back into localStorage
      CLICK_PARAMS.forEach(function (k) {
        var v = params.get(k);
        if (v) { saved[k] = { value: v.slice(0, 500), ts: Date.now() }; changed = true; }
      });
      var ref = externalReferrer();
      var hasUtm = UTM_PARAMS.some(function (k) { return params.get(k); });
      var clicked = CLICK_PARAMS.some(function (k) { return params.get(k); });
      // Meta's in-app browser and iOS link protection can drop ?fbclid and the referrer, yet Meta's
      // pixel still sets a fresh _fbc cookie. A _fbc newer than the last one we saw is a new ad click.
      var fbcTs = fbcTime(cookie('_fbc'));
      var lastFbc = saved.fbc_seen ? Number(saved.fbc_seen.value) : 0;
      var metaClick = fbcTs > lastFbc;
      if (metaClick) { saved.fbc_seen = { value: String(fbcTs), ts: Date.now() }; changed = true; }
      // The pixel can set _fbc a moment after this script runs on a tagged landing page, so only a click
      // clearly newer than the saved touch (over a minute) replaces it.
      var newTouch = hasUtm || clicked || !!ref ||
        (metaClick && !!saved.landing && fbcTs > saved.landing.ts + 60 * 1000);
      // A new arrival (tagged link, ad click or another site) replaces the whole touch, so an old
      // utm_source can't stick to a later visit that came from somewhere else.
      if (newTouch || !saved.landing) {
        UTM_PARAMS.forEach(function (k) {
          var v = params.get(k);
          if (v) saved[k] = { value: v.slice(0, 150), ts: Date.now() };
          else if (newTouch) delete saved[k];
        });
        if (ref) saved.referrer = { value: ref.slice(0, 100), ts: Date.now() };
        else if (newTouch) delete saved.referrer;
        saved.landing = { value: (location.pathname + location.search).slice(0, 300), ts: Date.now() };
        changed = true;
      }
      if (changed) Attribution.write(saved);
    },
    forQuote: function (eventId) {
      var a = Attribution.read();
      var val = function (k) { return a[k] ? a[k].value : ''; };
      // Meta's own cookie wins; otherwise build _fbc from the saved fbclid, in Meta's format.
      var fbc = cookie('_fbc') || (a.fbclid ? 'fb.1.' + a.fbclid.ts + '.' + a.fbclid.value : '');
      // gtag's conversion linker keeps the last Google click in _gcl_aw ("GCL.<time>.<gclid>").
      var gclAw = cookie('_gcl_aw').split('.').slice(2).join('.');
      return {
        event_id: eventId,
        page_url: location.href.split('#')[0],
        fbp: cookie('_fbp'),
        fbc: fbc,
        gclid: val('gclid') || gclAw,
        gbraid: val('gbraid'),
        wbraid: val('wbraid'),
        ttclid: val('ttclid'),
        utm_source: val('utm_source'),
        utm_medium: val('utm_medium'),
        utm_campaign: val('utm_campaign'),
        utm_content: val('utm_content'),
        utm_term: val('utm_term'),
        landing_page: val('landing'),
        referrer: val('referrer'),
      };
    },
  };

  function newEventId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'q-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function e164(phone) {
    var d = String(phone || '').replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return d ? '+' + d : '';
  }

  /** Loads Meta's pixel script if Shopify's sandboxed Meta app hasn't exposed a global fbq. */
  function ensureFbq() {
    if (!window.fbq) {
      var n = (window.fbq = function () {
        if (n.callMethod) n.callMethod.apply(n, arguments);
        else n.queue.push(arguments);
      });
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(s);
    }
  }

  /**
   * Funnel step tracking: sell page → quote builder → Add to Quote → quote form → Lead.
   * Sent as Meta custom events (pixel CGM) and Google tag events, and pushed to dataLayer.
   * opts.once = a key: fire that step only once per browser session.
   */
  var trackReady = false;
  function track(name, params, opts) {
    params = params || {};
    if (opts && opts.once) {
      var onceKey = 'scgm_step_' + opts.once;
      try {
        if (sessionStorage.getItem(onceKey)) return;
        sessionStorage.setItem(onceKey, '1');
      } catch (e) {}
    }
    try {
      if (META_PIXEL) {
        ensureFbq();
        if (!trackReady) {
          window.fbq('set', 'autoConfig', false, META_PIXEL);
          window.fbq('init', META_PIXEL);
          trackReady = true;
        }
        window.fbq('trackSingleCustom', META_PIXEL, name, params);
      }
    } catch (e) {}
    var snake = name.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    try { if (typeof window.gtag === 'function') window.gtag('event', snake, params); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var push = { event: 'scgm_' + snake };
      Object.keys(params).forEach(function (k) { push[k] = params[k]; });
      window.dataLayer.push(push);
    } catch (e) {}
  }
  window.SCGMTrack = track;

  /**
   * Browser-side Meta "Lead". Shopify's Meta app runs sandboxed (no global fbq), and the Zap's server-side
   * Lead can't carry the click ID / browser cookie / IP / user agent — the pixel sends all of those itself.
   * Same eventID as the Zap's Lead, so Meta counts the quote once.
   */
  function sendMetaLead(p) {
    if (!META_PIXEL || !p.event_id) return;
    ensureFbq();
    var lower = function (v) { return String(v || '').trim().toLowerCase(); };
    window.fbq('set', 'autoConfig', false, META_PIXEL); // only this event — no automatic button/page events
    // Advanced matching: the pixel hashes these before they leave the browser.
    window.fbq('init', META_PIXEL, {
      em: lower(p.email),
      ph: String(p.phone || '').replace(/\D/g, ''),
      fn: lower(p.fn),
      ln: lower(p.ln),
      ct: lower(p.ct).replace(/\s+/g, ''),
      st: lower(p.st),
      zp: String(p.zp || '').slice(0, 5),
      country: 'us',
    });
    window.fbq('trackSingle', META_PIXEL, 'Lead', { value: p.value, currency: 'USD' }, { eventID: p.event_id });
  }

  /** Runs on the thank-you page: one Google conversion + one Meta Lead per quote, with its real value. */
  function sendPendingConversion() {
    var pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {
      return;
    }
    if (!pending || Date.now() - pending.ts > 30 * 60 * 1000) return;
    try { sendMetaLead(pending); } catch (e) {}
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'generate_lead', {
      send_to: GA4_ID,
      value: pending.value,
      currency: 'USD',
      quote_number: pending.quote,
    });
    // Enhanced conversions: gtag hashes these before they leave the browser.
    window.gtag('set', 'user_data', { email: pending.email, phone_number: pending.phone });
    window.gtag('event', 'conversion', {
      send_to: GOOGLE_CONVERSION,
      value: pending.value,
      currency: 'USD',
      transaction_id: pending.quote, // Google drops repeats of the same quote number
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------------------------------------- header counter bubble */

  function updateCounter() {
    var count = Basket.count();
    document.querySelectorAll('a[href$="' + QUOTE_PAGE + '"]').forEach(function (link) {
      if (!link.closest('header, .header, sticky-header')) return;
      var bubble = link.querySelector('.scgm-quote-count');
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'scgm-quote-count';
        bubble.setAttribute('aria-hidden', 'true');
        link.style.position = 'relative';
        link.appendChild(bubble);
      }
      bubble.textContent = count;
      bubble.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ------------------------------------- product page: "Add to Quote" */

  function initProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.scgmQuote) return;
      var submit = form.querySelector('.product-form__submit, [name="add"]');
      if (!submit) return;
      form.dataset.scgmQuote = '1';

      // Same class the REF-code gate looks for (.product-form__quote), so the gate keeps working.
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-form__quote button button--full-width button--primary scgm-quote-btn';
      btn.innerHTML = '<span>Add to Quote</span>';
      submit.parentNode.insertBefore(btn, submit);

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (document.body.classList.contains('scgm-gate-lock')) return; // REF code not confirmed yet
        addFromForm(form, btn);
      });
    });
  }

  function productHandle(form) {
    var fromForm = form.getAttribute('data-product-handle');
    if (fromForm) return fromForm;
    var card = form.closest('[data-product-handle]');
    if (card) return card.getAttribute('data-product-handle');
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? match[1] : null;
  }

  function addFromForm(form, btn) {
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? String(idInput.value) : '';
    var handle = productHandle(form);
    if (!variantId || !handle) return;

    var scope = form.closest('.product__info-container, product-info, .product') || document;
    var qtyInput = form.querySelector('[name="quantity"]') || scope.querySelector('[name="quantity"]');
    var quantity = Math.max(1, Math.min(MAX_QTY, parseInt(qtyInput && qtyInput.value, 10) || 1));

    btn.disabled = true;
    btn.classList.add('loading');

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = product.variants.filter(function (v) { return String(v.id) === variantId; })[0];
        if (!variant) throw new Error('variant not found');
        var image = (variant.featured_image && variant.featured_image.src) || product.featured_image || '';
        Basket.add({
          variant_id: variantId,
          handle: product.handle,
          title: product.title,
          variant_title: variant.title === 'Default Title' ? '' : variant.title,
          sku: variant.sku || '',
          price: variant.price, // cents; display only — the server re-prices on submit
          image: image,
          quantity: quantity,
        });
        track('AddToQuote', {
          value: (variant.price * quantity) / 100,
          currency: 'USD',
          num_items: quantity,
          content_name: product.title,
          source: 'product_page',
        });
        setTimeout(function () { window.location.href = QUOTE_PAGE; }, 300);
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('loading');
        alert('Sorry, we could not add that item. Please refresh the page and try again.');
      });
  }

  /* -------------------------------------------------------- quote page */

  /* ------------------------------------------------- seller account prefill */

  // Custom seller accounts (/pages/account) keep a session token in localStorage. When one is present we
  // fill any EMPTY form field from the saved profile; otherwise we offer a sign-in link that comes back here.
  var ACCOUNT_KEY = 'scgm_session';
  var ACCOUNT_URL = '/pages/account';

  function accountSession() {
    try { var s = JSON.parse(localStorage.getItem(ACCOUNT_KEY) || 'null'); return s && s.token ? s : null; } catch (e) { return null; }
  }

  function signedOutNote(signInLink) {
    return '<strong>⭐ Earn Rewards status with this quote.</strong> Every quote you sell counts toward Silver, Gold &amp; Platinum — with bonus cash at every level. ' +
      'New here? Your free account is created when you submit. Sold to us before? <a href="' + signInLink + '">Sign in</a> to fill this in for you.';
  }

  function prefillFromAccount(root, form) {
    var note = root.querySelector('[data-scgm-account]');
    var api = (root.dataset.endpoint || '').replace(/\/+$/, '');
    var sess = accountSession();
    var signInLink = ACCOUNT_URL + '?return=' + encodeURIComponent(location.pathname);
    function say(html) { if (note) { note.innerHTML = html; note.hidden = false; } }
    function showAfter() { var a = root.querySelector('[data-scgm-account-after]'); if (a) a.hidden = false; }
    if (!sess || !api) {
      say(signedOutNote(signInLink)); showAfter();
      return;
    }
    fetch(api + '/account', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: sess.token }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res || !res.ok) {
          if (res && res.signed_out) { try { localStorage.removeItem(ACCOUNT_KEY); } catch (e) {} }
          say(signedOutNote(signInLink)); showAfter();
          return;
        }
        var p = res.profile || {};
        var fill = function (name, value) {
          var el = form.elements[name];
          if (el && !el.value && value) el.value = value;
        };
        fill('full_name', [p.first_name, p.last_name].filter(Boolean).join(' '));
        fill('email', p.email);
        fill('phone', p.phone);
        fill('address', p.address);
        fill('city', p.city);
        fill('state', p.state);
        fill('zip', p.zip);
        fill('payment_method', p.payment_method);
        fill('payment_username', p.payment_username);
        if (p.label_method && !form.querySelector('[name="label_method"]:checked')) {
          Array.prototype.forEach.call(form.querySelectorAll('[name="label_method"]'), function (r) { if (r.value === p.label_method) r.checked = true; });
        }
        say('Signed in as <strong>' + escapeHtml(p.email || sess.email || '') + '</strong>. We filled in your saved info — please double-check it. <a href="' + ACCOUNT_URL + '">My account</a>');
        // Sell CGM Rewards: tell them when a loyalty bonus will ride along on this quote.
        fetch(api + '/account/quotes', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: sess.token }) })
          .then(function (r) { return r.json(); })
          .then(function (q) {
            var l = q && q.ok && q.loyalty;
            if (!l || !note) return;
            note.innerHTML += l.available > 0
              ? '<br><strong>\u2b50 Your $' + Math.round(l.available) + ' loyalty bonus will be added to this quote.</strong>'
              : '<br>' + escapeHtml(l.tier) + ' member \u00b7 $' + Math.round(l.to_next_bonus) + ' more shipped to your next $' + l.bonus + ' bonus.';
            // Weekly bonus code (returning sellers): fill it in if the box is empty.
            var w = q && q.ok && q.weekly;
            var box = form.querySelector('[name="promo_code"]');
            if (w && w.code && box && !box.value) {
              box.value = w.code;
              note.innerHTML += '<br><strong>\ud83c\udf81 This week\'s bonus code ' + escapeHtml(w.code) + ' (+$' + Math.round(w.amount) + ') is filled in for quotes of $' + Math.round(w.minimum) + '+.</strong>';
            }
          })
          .catch(function () {});
      })
      .catch(function () {});
  }

  /** After a signed-in seller submits a quote, the info they used becomes their saved profile. */
  function saveAccountProfile(root, f) {
    var sess = accountSession();
    var api = (root.dataset.endpoint || '').replace(/\/+$/, '');
    if (!sess || !api) return;
    var parts = (f.full_name || '').split(/\s+/);
    var profile = {
      first_name: parts[0] || '', last_name: parts.slice(1).join(' '), phone: f.phone, address: f.address, city: f.city,
      state: f.state, zip: f.zip, payment_method: f.payment_method, payment_username: f.payment_username, label_method: f.label_method,
    };
    try {
      fetch(api + '/account/update', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: sess.token, profile: profile }) });
    } catch (e) {}
  }

  function initQuotePage() {
    var root = document.getElementById('scgm-quote');
    if (!root) return;

    var itemsEl = root.querySelector('[data-scgm-items]');
    var emptyEl = root.querySelector('[data-scgm-empty]');
    var filledEl = root.querySelector('[data-scgm-filled]');
    var form = root.querySelector('form[data-scgm-form]');
    var errorEl = root.querySelector('[data-scgm-error]');
    var submitBtn = form.querySelector('[type="submit"]');
    var bonusMin = parseFloat(root.dataset.bonusMinimum || '250') * 100;
    var bonusAmount = parseFloat(root.dataset.bonusAmount || '20') * 100;
    var bonusBox = form.querySelector('[name="new_customer_bonus"]');

    function render() {
      var items = Basket.read();
      emptyEl.hidden = items.length > 0;
      filledEl.hidden = items.length === 0;
      if (!items.length) return;

      var subtotal = items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
      var bonusOn = bonusBox && bonusBox.checked && subtotal >= bonusMin;

      var rows = items.map(function (i) {
        return (
          '<tr data-variant="' + escapeHtml(i.variant_id) + '">' +
          '<td class="scgm-q-product">' +
          (i.image ? '<img src="' + escapeHtml(i.image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<div><a href="/products/' + escapeHtml(i.handle) + '">' + escapeHtml(i.title) + '</a>' +
          (i.variant_title ? '<div class="scgm-q-variant">' + escapeHtml(i.variant_title) + '</div>' : '') +
          '<button type="button" class="scgm-q-remove link" data-remove>Remove</button></div></td>' +
          '<td class="scgm-q-price" data-label="Price">' + money(i.price) + '</td>' +
          '<td class="scgm-q-qty" data-label="Quantity">' +
          '<button type="button" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="number" min="1" max="' + MAX_QTY + '" value="' + i.quantity + '" inputmode="numeric" aria-label="Quantity">' +
          '<button type="button" data-step="1" aria-label="Increase quantity">+</button></td>' +
          '<td class="scgm-q-total" data-label="Total">' + money(i.price * i.quantity) + '</td></tr>'
        );
      }).join('');

      itemsEl.innerHTML =
        '<table class="scgm-q-table"><thead><tr><th>Product</th><th>Price</th><th>Quantity</th><th>Total</th></tr></thead>' +
        '<tbody>' + rows + '</tbody><tfoot>' +
        (bonusOn ? '<tr><td colspan="3">New Customer Bonus</td><td>' + money(bonusAmount) + '</td></tr>' : '') +
        '<tr class="scgm-q-grand"><td colspan="3">Your quote total</td><td>' + money(subtotal + (bonusOn ? bonusAmount : 0)) + '</td></tr>' +
        '</tfoot></table>' +
        (bonusBox && bonusBox.checked && subtotal < bonusMin
          ? '<p class="scgm-q-hint">Add ' + money(bonusMin - subtotal) + ' more to unlock the ' + money(bonusAmount) + ' new-customer bonus.</p>'
          : '');
    }

    itemsEl.addEventListener('click', function (e) {
      var row = e.target.closest('tr[data-variant]');
      if (!row) return;
      var id = row.getAttribute('data-variant');
      if (e.target.closest('[data-remove]')) {
        Basket.remove(id);
        render();
      } else if (e.target.closest('[data-step]')) {
        var step = parseInt(e.target.closest('[data-step]').getAttribute('data-step'), 10);
        var input = row.querySelector('input');
        Basket.setQty(id, (parseInt(input.value, 10) || 1) + step);
        render();
      }
    });
    itemsEl.addEventListener('change', function (e) {
      var row = e.target.closest('tr[data-variant]');
      if (!row || e.target.tagName !== 'INPUT') return;
      Basket.setQty(row.getAttribute('data-variant'), parseInt(e.target.value, 10) || 1);
      render();
    });
    if (bonusBox) bonusBox.addEventListener('change', render);

    // "Add more supplies" picker under the quote: add another product without leaving the page.
    var addEl = root.querySelector('[data-scgm-add]');
    if (addEl) {
      var addToggle = addEl.querySelector('[data-scgm-add-toggle]');
      var addPanel = addEl.querySelector('[data-scgm-add-panel]');
      addToggle.addEventListener('click', function () {
        var open = addPanel.hidden;
        addPanel.hidden = !open;
        addToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        addEl.classList.toggle('is-open', open);
      });
      addPanel.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-scgm-add-btn]');
        if (!btn) return;
        var card = btn.closest('[data-scgm-add-card]');
        var sel = card.querySelector('[data-scgm-add-variant]');
        var opt = sel.options[sel.selectedIndex];
        var id = String(sel.value);
        var price = parseInt(opt.getAttribute('data-price'), 10) || 0;
        var vt = opt.getAttribute('data-title') || '';
        Basket.add({
          variant_id: id,
          handle: card.getAttribute('data-handle'),
          title: card.getAttribute('data-title'),
          variant_title: vt === 'Default Title' ? '' : vt,
          sku: opt.getAttribute('data-sku') || '',
          price: price, // cents; display only - the Worker re-prices on submit
          image: card.getAttribute('data-image') || '',
          quantity: 1,
        });
        render();
        var row = itemsEl.querySelector('tr[data-variant="' + id + '"]');
        if (row) {
          row.classList.remove('scgm-q-flash');
          void row.offsetWidth;
          row.classList.add('scgm-q-flash');
        }
        btn.textContent = 'Added \u2713';
        btn.classList.add('is-added');
        setTimeout(function () { btn.textContent = 'Add'; btn.classList.remove('is-added'); }, 1400);
        track('AddToQuote', {
          value: price / 100,
          currency: 'USD',
          num_items: 1,
          content_name: card.getAttribute('data-title'),
          source: 'quote_page',
        });
      });
    }

    // Funnel step: the seller starts typing their details (once per session).
    form.addEventListener('focusin', function () {
      var items = Basket.read();
      track('StartQuoteForm', {
        value: items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0) / 100,
        currency: 'USD',
        num_items: items.reduce(function (n, i) { return n + i.quantity; }, 0),
      }, { once: 'form' });
    }, { once: true });

    // Refresh prices from Shopify so an old basket never shows a stale quote.
    function refreshPrices() {
      var items = Basket.read();
      var handles = items.map(function (i) { return i.handle; }).filter(function (h, n, all) { return all.indexOf(h) === n; });
      return Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var byVariant = {};
        products.forEach(function (p) {
          if (p) p.variants.forEach(function (v) { byVariant[String(v.id)] = v; });
        });
        var fresh = items.filter(function (i) { return byVariant[i.variant_id]; });
        fresh.forEach(function (i) { i.price = byVariant[i.variant_id].price; });
        if (products.every(Boolean)) Basket.write(fresh);
        render();
      });
    }

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = !message;
      if (message) errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showError('');
      if (!form.reportValidity()) return;

      var data = new FormData(form);
      var val = function (name) { return (data.get(name) || '').toString().trim(); };
      var eventId = newEventId();
      var payload = {
        tracking: Attribution.forQuote(eventId),
        items: Basket.read().map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }),
        website: val('website'), // honeypot
        account_token: (accountSession() || {}).token || '', // Sell CGM Rewards: bonus applies to signed-in sellers only
        turnstile_token: val('cf-turnstile-response'),
        form: {
          full_name: val('full_name'),
          email: val('email'),
          phone: val('phone'),
          address: val('address'),
          city: val('city'),
          state: val('state'),
          zip: val('zip'),
          label_method: val('label_method'),
          payment_method: val('payment_method'),
          payment_username: val('payment_username'),
          new_customer_bonus: data.get('new_customer_bonus') === 'on',
          promo_code: val('promo_code').toUpperCase(),
          agreed_terms: data.get('agreed_terms') === 'on',
          ack_sealed: data.get('ack_sealed') === 'on',
          ack_exact_items: data.get('ack_exact_items') === 'on',
        },
      };

      var label = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting Request…';

      fetch(root.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.error || '');
          Basket.clear();
          try { sessionStorage.removeItem(PROMO_KEY); } catch (e) {}
          if (payload.form.email.toLowerCase() === ((accountSession() || {}).email || '').toLowerCase()) saveAccountProfile(root, payload.form);
          try { sessionStorage.setItem('scgm_last_quote', JSON.stringify({ email: payload.form.email.toLowerCase(), quote: res.quote_number || '' })); } catch (e) {}
          try {
            sessionStorage.setItem(PENDING_KEY, JSON.stringify({
              quote: res.quote_number || res.quote || eventId,
              value: parseFloat(res.total) || 0,
              email: payload.form.email.toLowerCase(),
              phone: e164(payload.form.phone),
              event_id: eventId, // same ID the Worker hands the Zap, so Meta de-duplicates
              fn: payload.form.full_name.split(/\s+/)[0] || '',
              ln: payload.form.full_name.split(/\s+/).slice(1).join(' '),
              ct: payload.form.city,
              st: payload.form.state,
              zp: payload.form.zip,
              ts: Date.now(),
            }));
          } catch (e) {}
          window.location.href = root.dataset.thankYou || '/pages/thank-you';
        })
        .catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.textContent = label;
          showError(err.message || 'Something went wrong submitting your quote. Please try again, or email support@sellcgm.com.');
        });
    });

    render();
    refreshPrices();
    prefillFromAccount(root, form);
    fillPromoCode(form);
  }

  /* ------------------------------------------------ thank-you: account card */

  // After a quote, the thank-you page gets a card inviting the seller into their (already created) account.
  function initThankYouAccount() {
    if (!/^\/pages\/thank-you\/?$/.test(location.pathname)) return;
    var last = null;
    try { last = JSON.parse(sessionStorage.getItem('scgm_last_quote') || 'null'); } catch (e) {}
    var home = Array.prototype.slice.call(document.querySelectorAll('a[href="/"]')).filter(function (a) { return /back to home/i.test(a.textContent); })[0];
    if (!home || document.querySelector('.scgm-ty-acct')) return;
    var sess = accountSession();
    var email = last && last.email ? last.email : '';
    var signedIn = sess && email && sess.email && sess.email.toLowerCase() === email;
    var link = ACCOUNT_URL + (signedIn || !email ? '' : '?email=' + encodeURIComponent(email));
    var card = document.createElement('div');
    card.className = 'scgm-ty-acct';
    card.setAttribute('style', 'max-width:460px;margin:0 auto 26px;text-align:left;border:1px solid rgba(0,232,135,.45);background:rgba(0,232,135,.08);border-radius:14px;padding:18px 20px;font-family:inherit');
    card.innerHTML = signedIn
      ? '<p style="margin:0 0 6px;color:#fff;font-weight:800;font-size:17px">⭐ This quote counts toward your Rewards status</p>' +
        '<p style="margin:0 0 14px;color:rgba(255,255,255,.75);font-size:15px;line-height:1.55">Follow it step by step in your account — label, delivery, inspection and payout.</p>' +
        '<a href="' + link + '" style="display:inline-block;background:#00e887;color:#060d1f;font-weight:800;font-size:15px;text-decoration:none;padding:12px 22px;border-radius:999px">Track my quote</a>'
      : '<p style="margin:0 0 6px;color:#fff;font-weight:800;font-size:17px">⭐ Your Sell CGM account is ready</p>' +
        '<p style="margin:0 0 14px;color:rgba(255,255,255,.75);font-size:15px;line-height:1.55">' + (email ? 'We set it up with <strong style="color:#fff">' + escapeHtml(email) + '</strong>. ' : '') +
        'Sign in to track this quote live and start climbing Rewards status — <strong style="color:#fff">Silver, Gold &amp; Platinum</strong>, with bonus cash at every level. No password needed.</p>' +
        '<a href="' + link + '" style="display:inline-block;background:#00e887;color:#060d1f;font-weight:800;font-size:15px;text-decoration:none;padding:12px 22px;border-radius:999px">Track my quote &amp; rewards</a>';
    home.parentNode.insertBefore(card, home);
  }

  /* -------------------------------------------------------- bonus codes */

  // Text-campaign bonus codes: a link like sellcgm.com/pages/sell?code=TEXT10 remembers the code for this visit
  // and fills it in on the quote form. The Worker decides whether a code is valid; nothing is trusted here.
  var PROMO_KEY = 'scgm_promo_code';
  function rememberPromoCode() {
    try {
      var code = new URLSearchParams(location.search).get('code');
      if (code && /^[A-Za-z0-9]{3,20}$/.test(code)) sessionStorage.setItem(PROMO_KEY, code.toUpperCase());
    } catch (e) {}
  }
  function fillPromoCode(form) {
    var input = form.querySelector('[name="promo_code"]');
    if (!input || input.value) return;
    try { input.value = sessionStorage.getItem(PROMO_KEY) || ''; } catch (e) {}
  }

  /* -------------------------------------------------------------- boot */

  function boot() {
    rememberPromoCode();
    Attribution.capture();
    sendPendingConversion();
    initProductForms();
    initQuotePage();
    initThankYouAccount();
    updateCounter();
    // Dawn re-renders the product form when a variant changes; re-attach if needed.
    setInterval(initProductForms, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
